import { GlobalAxios } from "../axios/axios-config";
import { ISectorEmr } from "../models/sector-emr";

const SECTOR_EMR_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/SectorEmr";

export const sectorEmr = (params?: any) => {
  return GlobalAxios.get<ISectorEmr[]>(SECTOR_EMR_ROUTE, {
    params,
  });
};
